import React from "react";
import images from "components/images";

const ArmaUnits = () => (
  <a
    href="https://units.arma3.com/unit/combinedarmsmilsim"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src={images["Arma3Units"]}
      width="200"
      height="130"
      alt={"teamspeak"}
    />
  </a>
);

export default ArmaUnits;
